import {production} from "../config";

//TODO
export const clexxAPI = production===true ? 'https://us-central1-clexx-eaebf.cloudfunctions.net/' : 'https://europe-west3-clexx-dev-4c089.cloudfunctions.net/';
// export const clexxAPI = 'http://localhost:5001/clexx-dev-4c089/europe-west3/'
